module.exports = __webpack_public_path__ + "static/google-play-badge-37983af417123623c58d932fe0471481.png";